import { IInstitutionRepository, InstitutionInformation } from "../../../domain/institution";
import { InstitutionInformationTranslator } from "./InstitutionInformationTranslator";
import { AuthenticatedService } from "../../../infrastructure";

export class InstitutionRepository extends AuthenticatedService implements IInstitutionRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  public async getPatientRelatedInstitutionInformation(key: string, patientId: string): Promise<InstitutionInformation> {
    if (!key) { throw new Error("key is empty!!!"); }
    if (!patientId) { throw new Error("patientId is empty!!!"); }
    const url = "/api/patient/" + patientId + "/institution-information";
    const query = {
      params: {
        token: this.token,
        fileName: key,
      }
    };
    const result = await this.get(url, query);
    const translator = new InstitutionInformationTranslator();
    return translator.toInformation(result.data);
  }
}
